import { getCurrentUserId } from './getCurrentUserId';

declare var pdc: any;

export function checkPermissionAllowDefault(name, userId, glob) {
    var isAllowed = glob.PermissionsStore.checkPermission(userId, name);

    return isAllowed == null ? true : isAllowed;
}

export function checkPermissionDenyDefault(name, userId, glob) {
    var isAllowed = glob.PermissionsStore.checkPermission(userId, name);

    return isAllowed == null ? false : isAllowed;
}

export function canEdit(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('EditWorkspaces', userId, glob);
}

export function showSideBar(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('ShowMenu', userId, glob);
}

export function showSideBarCommon(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('ShowCommon', userId, glob);
}

export function showSideBarRecent(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('ShowRecent', userId, glob);
}

export function showSideBarFavourites(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('ShowFavourites', userId, glob);
}

export function showSideBarBrowse(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('ShowBrowse', userId, glob);
}

export function showSideBarMyOwn(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('ShowMyOwn', userId, glob);
}

export function showSideBarCommonAsMenu(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionDenyDefault('ShowCommonAsMenu', userId, glob);
}

export function showSideBarCommonSubFolders(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionDenyDefault('ShowCommonSubFolders', userId, glob);
}

export function editThemes(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('EditThemes', userId, glob);
}

export function editAppSettings(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('EditAppSettings', userId, glob);
}

export function editUsersAndGroups(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('EditUsersAndGroups', userId, glob);
}

export function allowExport(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('Export', userId, glob);
}

export function createAdminWidgets(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('CreateAdminWidgets', userId, glob);
}

export function editGlobalPermissions(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('EditGlobalPermissions', userId, glob);
}

export function editDataSources(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('EditDataSources', userId, glob);
}

export function editResources(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('EditResources', userId, glob);
}

export function showMaximize(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('ShowMaximize', userId, glob);
}

export function showCreateWidgetLink(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('ShowCreateWidgetLink', userId, glob);
}

export function createWorkspaceLink(userId = getCurrentUserId(), glob = pdc.platform.glob) {
    return checkPermissionAllowDefault('CreateWorkspaceLink', userId, glob);
}

export function checkPermission(
    permissionName,
    allowDefault = true,
    userId = getCurrentUserId(),
    glob = pdc.platform.glob
) {
    var checkFunction = allowDefault ? checkPermissionAllowDefault : checkPermissionDenyDefault;

    return checkFunction(permissionName, userId, glob);
}
